<script>
  export default {
    name: 'material-periods-fines-card',
    data: () => ({
      tableData: [
        { item: `New Books`, period: '14', fine: '.10', maxFine: '5.00' },
        { item: `New Audio Books`, period: '14', fine: '.05', maxFine: '5.00' },
        { item: `Books`, period: '28', fine: '.05', maxFine: '3.00' },
        { item: `Audio Bks/Playaways`, period: '14', fine: '.05', maxFine: '5.00' },
        { item: `Electronic Devices`, period: '14', fine: '1.00', maxFine: '10.00' },
        { item: `Music CDs`, period: '7', fine: '.05', maxFine: '3.00' },
        { item: `Mobile Hotspots`, period: '14', fine: '10.00', maxFine: '100.00' },
        { item: `Children's Music CDs`, period: '14', fine: '.05', maxFine: '3.00' },
        { item: `Children's AV Kits`, period: '14', fine: '.10', maxFine: '5.00' },
        { item: `DVD's`, period: '3/7', fine: '1.00', maxFine: '10.00' },
        { item: `Google Chromebooks`, period: '14', fine: '10.00', maxFine: '100.00' },
        { item: `Paperback Books`, period: '28', fine: '.05', maxFine: '3.00' },
        { item: `Magazines`, period: '7/28', fine: '.05', maxFine: '3.00' },
        { item: `Children's Big Books`, period: '14', fine: '.10', maxFine: '53.00' },
        { item: `Pamphlets`, period: '28', fine: '.05', maxFine: '3.00' },
        { item: `Museum Passes`, period: '3', fine: '20.00', maxFine: '200.00' }
      ],
      tableHeaders: [
        {
          text: 'Material',
          align: 'start',
          sortable: true,
          value: 'item'
        },
        { text: 'Period (days)', sortable: true, value: 'period' },
        { text: 'Fine ($)', sortable: true, value: 'fine' },
        { text: 'Max Fine ($)', sortable: true, value: 'maxFine' }
      ]
    })
  }
</script>

<template>
  <v-card max-width="700" width="100%" class="mt-16">
    <v-card-title class="text-h5 font-weight-bold primary secondary--text"> Material loan periods & fines </v-card-title>
    <v-card-text class="card-text primary--text font-weight-bold">
      <v-data-table dense :headers="tableHeaders" hide-default-footer :items="tableData" :items-per-page="50" item-key="material"></v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  >>> .v-card__title {
    white-space: wrap;
    word-break: break-word;
  }
</style>
